import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LocalDatePipe } from '@anihis/shared/src/pipes/local-date.pipe';
import { CommonModule } from '@angular/common';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
  MatDialogActions,
} from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { PetCoatColors } from '@anihis/shared/src/enum/pet-coat-colors';
import { ParseUtcToLocalPipe } from '@anihis/shared/src/pipes/parse-utc-to-local.pipe';
import { CloseOnEscDirective } from '../../../../shared/directive/closeOnEscDirective.directive';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'anihis-info-animal-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatDialogActions,
    MatListModule,
    MatDividerModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    TranslocoModule,
    ParseUtcToLocalPipe,
    CloseOnEscDirective,
    LocalDatePipe,
  ],
  templateUrl: './info-animal-dialog.component.html',
  styleUrls: ['./info-animal-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoAnimalDialogComponent {
  dialogRef = inject(MatDialogRef<InfoAnimalDialogComponent>);
  data = inject(MAT_DIALOG_DATA);
  colorPalette: string[] = Object.values(PetCoatColors);
  colorHexes!: string[];

  constructor() {
    if (this.data?.color) {
      if (!this.data || !Array.isArray(this.data?.color)) return;

      this.colorHexes = this.data.color
        .filter((colorKey: string) => colorKey in PetCoatColors)
        .map((colorKey: keyof typeof PetCoatColors) => PetCoatColors[colorKey]);
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
